import { render, staticRenderFns } from "./RuleGroupForm.vue?vue&type=template&id=48fc11ee&"
import script from "./RuleGroupForm.vue?vue&type=script&lang=js&"
export * from "./RuleGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports